import {ChangeDetectorRef, Component, Input, OnInit} from '@angular/core';
import {DocumentsServiceService} from '../../services/documents-service.service';
import {FormBuilder} from '@angular/forms';
import {ToastrService} from 'ngx-toastr';
import {PopupService} from '../../services/shared/popup.service';
import {ApplicationService} from '../../services/application.service';
import {DocumenttypeService} from '../../services/documenttype.service';
import {ActivatedRoute, Router} from '@angular/router';
import {PermitService} from '../../services/permit.service';
import {VehicleService} from '../../services/vehicle.service';
import {AuthWebService} from '../../services/authweb.service';
import {ScannerService} from '../../services/scanner.service';
import {ConfirmDialogService} from '../../services/shared/confirm-dialog/confirm-dialog.service';
import {UtilityServiceService} from '../../services/utility-service.service';
import {DomSanitizer} from '@angular/platform-browser';
import {PermitTypeDocumentService} from '../../services/permit-type-document.service';
import {DatePipe} from '@angular/common';

@Component({
  selector: 'app-document-viewer',
  templateUrl: './document-viewer.component.html',
  styleUrls: ['./document-viewer.component.css']
})
export class DocumentViewerComponent implements OnInit {

  //Document Viewer
  isLoadingImg: boolean;
  doc: any;
  isPDF: number;
  @Input() uploadedDocs:any = [];

  constructor( private sanitizer: DomSanitizer,private documentService: DocumentsServiceService) {}

  ngOnInit(): void {

    console.log("Uploaded Docs", this.uploadedDocs)
  }

  viewDoc(file){
    console.log("Uploaded Docs", this.uploadedDocs)

    console.log("View Document",file)
    if(file!=undefined){
      this.isLoadingImg = true;
      this.doc = null;
      this.isPDF = 0;
     //TO DO:
      let id = file.shareId ?? file.document_link.substring(file.document_link.indexOf('#')+1);
      document.getElementById("btnView").click();
      console.log("Document Id",id)
      if(file.document_link.includes('.pdf')){
        this.documentService.downloadpdf(id).subscribe(x => {
          let objectURL = URL.createObjectURL(x);
          this.doc = objectURL;
          this.isPDF = 1;

          this.isLoadingImg = false;
        })
        return
      }
      this.documentService.download(id).subscribe(x => {
        let objectURL = URL.createObjectURL(x);
        this.isPDF = 2;
        this.doc = this.sanitizer.bypassSecurityTrustUrl(objectURL);
        this.isLoadingImg = false;
      })
    }
  }

}
